export const SEARCH_OPERATORS = {
  EQUAL: "EQUAL",
  LIKE: "LIKE",
  CONTAINS: "CONTAINS",
  GREATER_THAN: "GREATER_THAN",
  LESS_THAN: "LESS_THAN",
  GREATER_THAN_OR_EQUAL: "GREATER_THAN_OR_EQUAL",
  LESS_THAN_OR_EQUAL: "LESS_THAN_OR_EQUAL",
};

export const FILTER_DATA_TYPES = {
  STRING: "string",
  NUMBER: "number",
  DATE: "date",
  STATUS_CODE: "status_code",
  BOOLEAN: "boolean",
};
export const STATUS_CODE_OPERATORS = [{ value: "EQUAL", label: "Equals" }];
export const BOOLEAN_OPERATORS = [{ value: "EQUAL", label: "Equals" }];
export const FILTER_STEPS = {
  SELECT_FIELD: "SELECT_FIELD",
  SELECT_OPERATOR: "SELECT_OPERATOR",
  ENTER_VALUE: "ENTER_VALUE",
};

// Client requirement: string fields only support "Contains" operator
export const STRING_OPERATORS = [
  // { value: "EQUAL", label: "Equals" },
  { value: "LIKE", label: "Contains" },
];

// Client requirement: integer fields only support "Contains" operator
export const NUMBER_OPERATORS = [
  { value: "CONTAINS", label: "Contains" },
  // { value: "EQUAL", label: "Equals" },
  // { value: "GREATER_THAN", label: "Greater than" },
  // { value: "GREATER_THAN_OR_EQUAL", label: "Greater or equal" },
  // { value: "LESS_THAN", label: "Less than" },
  // { value: "LESS_THAN_OR_EQUAL", label: "Less or equal" },
];

// Internal operators for number "Contains" — not shown in UI, used in normalizeFiltersForApi
// Converts user input to a range: e.g. 82 → GREATER_THAN 82 and LESS_THAN 83
export const NUMBER_CONTAINS_OPERATORS = [
  { value: "GREATER_THAN_OR_EQUAL", label: "Greater or equal" },
  { value: "LESS_THAN", label: "Less than" },
];

export const DATE_OPERATORS = [
  { value: "EQUAL", label: "On" },
  { value: "LESS_THAN", label: "Before" },
  { value: "LESS_THAN_OR_EQUAL", label: "On or before" },
  { value: "GREATER_THAN", label: "After" },
  { value: "GREATER_THAN_OR_EQUAL", label: "On or after" },
];
export const OPERATORS_BY_TYPE = {
  [FILTER_DATA_TYPES.STRING]: STRING_OPERATORS,
  [FILTER_DATA_TYPES.NUMBER]: NUMBER_OPERATORS,
  [FILTER_DATA_TYPES.DATE]: DATE_OPERATORS,
  [FILTER_DATA_TYPES.STATUS_CODE]: STATUS_CODE_OPERATORS,
  [FILTER_DATA_TYPES.BOOLEAN]: BOOLEAN_OPERATORS,
};
export const ON_DATE_OPERATOR_LABEL = "On";
export const GTE_OPERATOR_LABEL = "Greater or equal";
export const LTE_OPERATOR_LABEL = "Less or equal";
